import ACL, { ALL_WILDCARD } from '../crs/ACL';

export const rootACL = new ACL('root');

export const rootAcls = {
  ALL: rootACL.concat(ALL_WILDCARD),
};
